import { query, where } from 'firebase/firestore';
import { ExternalConnectionsTypes } from 'shared/types/external-connections';

import { externalConnectionsConverter } from './converters/external-connections';
import { CollectionOptions, getAuthentication, getCollection } from './helpers';

export const getExternalCalendarConnectionsQuery = async () => {
  const auth = await getAuthentication();

  const conditions = [
    where('roles.all', 'array-contains', auth.currentUser?.uid),
    where('type', '==', ExternalConnectionsTypes.Calendar),
  ];

  return query(
    getCollection(CollectionOptions.ExternalConnections).withConverter(
      externalConnectionsConverter,
    ),
    ...conditions,
  );
};
